
export default function roundCustom(number, decimalPlaces) {
    const mult = Math.pow(10, (decimalPlaces !== undefined ? decimalPlaces : 2));
    return Math.round(parseFloat(number) * mult) / mult;
}

export function floorCustom(number, decimalPlaces) {
    const mult = Math.pow(10, (decimalPlaces !== undefined ? decimalPlaces : 2));
    return Math.floor(parseFloat(number) * mult) / mult;
}